"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classPrivateFieldSet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldSet"));

var _classPrivateFieldGet2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldGet"));

var _lodash = require("lodash");

var _wujiApi = _interopRequireDefault(require("./wujiApi"));

var _common = require("./utils/common");

var _envHost = new WeakMap();

var _projectId = new WeakMap();

var _tableSchemaCache = new WeakMap();

/**
 * 全局的公共数据存储类
 */
var DataStore = /*#__PURE__*/function () {
  function DataStore() {
    (0, _classCallCheck2["default"])(this, DataStore);

    _envHost.set(this, {
      writable: true,
      value: ''
    });

    _projectId.set(this, {
      writable: true,
      value: ''
    });

    _tableSchemaCache.set(this, {
      writable: true,
      value: {}
    });

    this.pageId = '';
    this.env = '';
    this.mode = '';
    this.fetchQuery = {};
  }

  (0, _createClass2["default"])(DataStore, [{
    key: "getSchemaByTableKeys",

    /**
     * 返回需要的schema集
     * @param {*} keyArray 指定的table key集
     */
    value: function () {
      var _getSchemaByTableKeys = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(keyArray) {
        var allPromise, errMsg, wujiApi, that, result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                allPromise = [];
                errMsg = [];
                wujiApi = new _wujiApi["default"]({
                  errMsg: errMsg
                });
                that = this; // 如果不在全局的缓存中，则从无极api的并行请求

                keyArray.forEach(function (key) {
                  if (!(0, _classPrivateFieldGet2["default"])(that, _tableSchemaCache)[key]) {
                    var keys = key.split('.');
                    allPromise.push(wujiApi.getSchemaList(keys[0], keys[1]).then(function (data) {
                      if (data) {
                        (0, _classPrivateFieldGet2["default"])(that, _tableSchemaCache)[key] = data;
                      }
                    }));
                  }
                });
                _context.next = 7;
                return (0, _common.allSettled)(allPromise);

              case 7:
                if (!(errMsg.length > 0)) {
                  _context.next = 9;
                  break;
                }

                throw Error("dataManager getSchemaByTableKey error:[".concat(errMsg.toString(), "]"));

              case 9:
                result = {};
                keyArray.forEach(function (key) {
                  result[key] = (0, _classPrivateFieldGet2["default"])(that, _tableSchemaCache)[key];
                });
                return _context.abrupt("return", (0, _lodash.cloneDeep)(result));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSchemaByTableKeys(_x) {
        return _getSchemaByTableKeys.apply(this, arguments);
      }

      return getSchemaByTableKeys;
    }()
  }, {
    key: "projectId",
    get: function get() {
      return (0, _classPrivateFieldGet2["default"])(this, _projectId);
    },
    set: function set(value) {
      if (!value) {
        console.warn('dataManager projectId 设置无效', value);
      }

      (0, _classPrivateFieldSet2["default"])(this, _projectId, value);
    }
  }, {
    key: "envHost",
    get: function get() {
      return (0, _classPrivateFieldGet2["default"])(this, _envHost);
    },
    set: function set(value) {
      if (!value) {
        console.error('dataManager envHost 设置无效', value);
      }

      (0, _classPrivateFieldSet2["default"])(this, _envHost, value);
    }
  }]);
  return DataStore;
}();

var _default = new DataStore();

exports["default"] = _default;